/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEcommContentTemplate3ViewProps } from './ecomm-content-template-3';

/**
 *
 * EcommContentTemplate1View component
 * @extends {React.PureComponent<IEcommContentTemplate3ViewProps>}
 */
 export class EcommContentTemplate3View extends React.PureComponent<IEcommContentTemplate3ViewProps> {
  public render(): JSX.Element | null {
    const { config, anchorID, TemplateContainerStyle } = this.props;

    const resultStyle = config.className && config.className !== '' ? `${TemplateContainerStyle.classname}` + ` ` + `${config.className}` : TemplateContainerStyle.className;

    if (anchorID) {
      const style = `anchor ` + `${resultStyle}`;

      return <div id ={anchorID} className={style}>{this._renderImage()}</div>;
    }

    return <div className={resultStyle}>{this._renderImage()}</div>;
  }

  private _renderImage(): JSX.Element | null {
    const { firstImage, secondImage, thirdImage, ImageContainerStyle, NoImage } = this.props;

    let imgFirst = firstImage && firstImage.src ? <img src={firstImage.src} alt='' role='presentation'/> : <div className={NoImage.className}/>;
    let imgSecond = secondImage && secondImage.src ? <img src={secondImage.src} alt='' role='presentation'/> : <div className={NoImage.className}/>;
    let imgThird = thirdImage && thirdImage.src ? <img src={thirdImage.src} alt='' role='presentation'/> : <div className={NoImage.className}/>;

    return (
      <div className={ImageContainerStyle.className}>
        <div>{imgFirst}</div>
        <div className='row'>
          <div className='col-12 col-sm-6'>{imgSecond}</div>
          <div className='col-12 col-sm-6'>{imgThird}</div>
        </div>
      </div>
    );
  }
 }

export default EcommContentTemplate3View;